/**
 * Environment configuration reader
 * Provides safe access to environment variables with defaults
 */

const env = {
  // Firebase
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
  },

  // App
  app: {
    name: import.meta.env.VITE_APP_NAME || 'GoFood',
    env: import.meta.env.VITE_APP_ENV || 'development',
  },

  // Flags
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,

  // Emulators - only connect when explicitly enabled
  useEmulators: import.meta.env.VITE_USE_EMULATORS === 'true',
}

/**
 * Validate required environment variables
 * @returns {boolean} True if all required variables are present
 */
export function validateEnv() {
  const required = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
  ]

  const missing = required.filter((key) => !import.meta.env[key])

  if (missing.length > 0) {
    console.warn(`[ENV] Missing required environment variables: ${missing.join(', ')}`)
    return false
  }

  return true
}

export default env
